<span>
  <ng-content></ng-content>
</span>

<i data-e2e="close" class="icon close" *ngIf="isClosable">
  <svg  (click)="close()"  width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M7.297 8.002L4.113 4.817l.707-.707 3.184 3.185 3.18-3.18.707.707-3.18 3.18 3.18 3.18-.707.706-3.18-3.18-3.184 3.185-.707-.707z" fill="#2E2E2E" fill-rule="evenodd"/></svg>
</i>
